document.addEventListener('DOMContentLoaded', function () {
  const insurePrdForm = document.querySelector(".insurance_prd_frm [data-insurance-prdvr-id]");
  const insuranceVariantId = insurePrdForm ? Number(insurePrdForm?.value) : Number(document.body.dataset.instantPrdId);

  // --- Throttled cart fetch to prevent 429 errors ---
  // Shares cache with Shopify.getCart() in global.js to avoid duplicate requests
  let _cachedCart = null;
  let _cartFetchedAt = 0;
  const CART_CACHE_MS = 5000; // Cache cart data for 5 seconds
  let _cartFetchPromise = null;

  async function getCart(retries = 3) {
    const now = Date.now();
    // Drop our own cache if the cart was mutated anywhere since we cached it (global.js hook)
    if (typeof Shopify !== 'undefined' && Shopify._cartInvalidatedAt && _cartFetchedAt <= Shopify._cartInvalidatedAt) {
      _cachedCart = null;
      _cartFetchedAt = 0;
    }
    // Check our own cache first
    if (_cachedCart && (now - _cartFetchedAt) < CART_CACHE_MS) {
      return _cachedCart;
    }
    // Also check Shopify global cache (shared with Shopify.getCart in global.js)
    if (typeof Shopify !== 'undefined' && Shopify._cartCache && Shopify._cartCacheTime && (now - Shopify._cartCacheTime) < CART_CACHE_MS) {
      _cachedCart = Shopify._cartCache;
      _cartFetchedAt = Shopify._cartCacheTime;
      return _cachedCart;
    }
    // If a fetch is already in flight, wait for it instead of starting a new one
    if (_cartFetchPromise) {
      return _cartFetchPromise;
    }
    _cartFetchPromise = (async () => {
      for (let attempt = 0; attempt < retries; attempt++) {
        try {
          const cartResponse = await fetch('/cart.js');
          if (cartResponse.status === 429) {
            // Rate limited - wait with exponential backoff then retry
            const waitMs = Math.min(2000 * Math.pow(2, attempt), 8000);
            console.warn(`Cart API rate limited (429). Retrying in ${waitMs}ms... (attempt ${attempt + 1}/${retries})`);
            await new Promise(r => setTimeout(r, waitMs));
            continue;
          }
          if (!cartResponse.ok) throw new Error(`Cart fetch failed: ${cartResponse.status}`);
          const cart = await cartResponse.json();
          _cachedCart = cart;
          _cartFetchedAt = Date.now();
          // Update global Shopify cache so other scripts don't re-fetch
          if (typeof Shopify !== 'undefined') {
            Shopify._cartCache = cart;
            Shopify._cartCacheTime = _cartFetchedAt;
          }
          return cart;
        } catch (error) {
          if (attempt === retries - 1) throw error;
          const waitMs = Math.min(2000 * Math.pow(2, attempt), 8000);
          await new Promise(r => setTimeout(r, waitMs));
        }
      }
      // All retries exhausted with 429 - return cached data if available, otherwise return null
      if (_cachedCart) return _cachedCart;
      return null;
    })();
    try {
      return await _cartFetchPromise;
    } finally {
      _cartFetchPromise = null;
    }
  }

  // Invalidate cache when we know cart changed
  function invalidateCartCache() {
    _cachedCart = null;
    _cartFetchedAt = 0;
    if (typeof Shopify !== 'undefined' && Shopify.invalidateCartCache) {
      Shopify.invalidateCartCache();
    }
  }

  // --- Debounce helper ---
  function debounce(fn, ms) {
    let timer;
    return function(...args) {
      clearTimeout(timer);
      return new Promise(resolve => {
        timer = setTimeout(async () => {
          resolve(await fn.apply(this, args));
        }, ms);
      });
    };
  }

  // Flag to pause mutation observer during our own updates
  let _isUpdatingCartDOM = false;

  async function addInsuranceToCart() {
    try {
      const cart = await getCart();
      if (!cart || !cart.items) return;
      const insuranceItem = cart.items.find(item => item.variant_id == insuranceVariantId);
     

      if (!insuranceItem) {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: insuranceVariantId,
              quantity: 1
            }]
          })
        });

        if (!response.ok) throw new Error(`Cart add failed: ${response.status}`);
        const data = await response.json();
        invalidateCartCache();

        if (data) {
          document.querySelector("input[name='insure_prd_input']")?.setAttribute('line_item_key', data?.items[0]?.key);
        }
      } else {
        console.log('Insurance already added to the cart');
      }
    } catch (error) {
      console.error('Error adding insurance:', error);
    }
  }

  const updateItem = async (data, retries = 3) => {
    for (let attempt = 0; attempt < retries; attempt++) {
      try {
        const req = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        });

        if (req.status === 429) {
          const waitMs = Math.min(1000 * Math.pow(2, attempt), 5000);
          console.warn(`Cart change rate limited (429). Retrying in ${waitMs}ms... (attempt ${attempt + 1}/${retries})`);
          await new Promise(r => setTimeout(r, waitMs));
          continue;
        }

        if (!req.ok) {
          throw new Error('Failed to update cart');
        }
        invalidateCartCache();
        document.querySelector('[line_item_key]')?.removeAttribute('line_item_key');
        return;
      } catch (error) {
        if (attempt === retries - 1) {
          console.error('Error updating item:', error);
        } else {
          const waitMs = Math.min(1000 * Math.pow(2, attempt), 5000);
          await new Promise(r => setTimeout(r, waitMs));
        }
      }
    }
  };

  // Update cart without syncing checkbox state (used when user manually toggles)
  const updateCartWithoutSync = async () => {
    if (document.querySelector(".cart.template-cart")) return;

    try {
      _isUpdatingCartDOM = true;
      const response = await fetch('/cart?view=ajax_side_cart', {
        method: 'GET',
        cache: 'no-cache'
      });

      const data = await response.text();
      const cartHTML = document.createElement('div');
      cartHTML.innerHTML = data;

      const cartTotalPrice = cartHTML.querySelector(".previewCartTotalsPrice")?.innerHTML;
      if (cartTotalPrice) {
        document.querySelector(".previewCartTotalsPrice").innerHTML = cartTotalPrice;
        const total = cartHTML.querySelector('[data-cart-total-value]').getAttribute('data-cart-total-value');
        const width = (total / (free_shipping_price * 100)) * 100;
        const message = width < 100 ? `<span>You are </span>${Shopify.formatMoney((((free_shipping_price * 100) - total)), window.money_format)}<span> away from </span><span class="text"> FREE SHIPPING!</span>` : `<span>You qualify for free shipping!</span>`

        document.querySelector('.progress-meter').style.width = `${width >= 100 ? 100 : width}%`;
        document.querySelector('.message[data-shipping-message]').innerHTML = message;
      }
      else if (cartHTML.querySelector(".previewCart")) {
        document.querySelector('.previewCart').innerHTML = cartHTML.querySelector(".previewCart").innerHTML;
        document.querySelector('.previewCartTool')?.remove();
        document.querySelector('.popup-toolDowns')?.remove();
        document.querySelector('.previewCartInfo')?.remove();
        document.querySelector('[data-shipping-progress]')?.classList.add('progress-hidden', 'none');
        document.querySelector('.message[data-shipping-message]').innerHTML = `Free shipping for all orders over ${Shopify.formatMoney((free_shipping_price * 100), window.money_format)}!`;
      }

      // After cart HTML is replaced, enforce user's choice IMMEDIATELY
      await delay(50);
      const insurePrdInputAfterUpdate = document.querySelector('input[name="insure_prd_input"]');
      if (insurePrdInputAfterUpdate) {
        const userChoice = sessionStorage.getItem('insure_prd_user_choice');
        const manuallyToggled = sessionStorage.getItem('insure_prd_manually_toggled');
        
        // If user wants it OFF, enforce it immediately
        if (manuallyToggled === 'true' && userChoice === 'off') {
          insurePrdInputAfterUpdate.checked = false;
          insurePrdInputAfterUpdate.removeAttribute('checked');
        }
      }
      
      // Ensure insurance product is hidden in cart list
      hideInsuranceProductInCart();
    } catch (error) {
      console.error('Error updating item:', error);
    } finally {
      _isUpdatingCartDOM = false;
    }
  };

  const updateCart = async () => {
    if (document.querySelector(".cart.template-cart")) return;

    try {
      _isUpdatingCartDOM = true;
      const response = await fetch('/cart?view=ajax_side_cart', {
        method: 'GET',
        cache: 'no-cache'
      });

      const data = await response.text();
      const cartHTML = document.createElement('div');
      cartHTML.innerHTML = data;

      const cartTotalPrice = cartHTML.querySelector(".previewCartTotalsPrice")?.innerHTML;
      if (cartTotalPrice) {
        document.querySelector(".previewCartTotalsPrice").innerHTML = cartTotalPrice;
        const total = cartHTML.querySelector('[data-cart-total-value]').getAttribute('data-cart-total-value');
        const width = (total / (free_shipping_price * 100)) * 100;
        const message = width < 100 ? `<span>You are </span>${Shopify.formatMoney((((free_shipping_price * 100) - total)), window.money_format)}<span> away from </span><span class="text"> FREE SHIPPING!</span>` : `<span>You qualify for free shipping!</span>`

        document.querySelector('.progress-meter').style.width = `${width >= 100 ? 100 : width}%`;
        document.querySelector('.message[data-shipping-message]').innerHTML = message;
      }
      else if (cartHTML.querySelector(".previewCart")) {
        document.querySelector('.previewCart').innerHTML = cartHTML.querySelector(".previewCart").innerHTML;
        document.querySelector('.previewCartTool')?.remove();
        document.querySelector('.popup-toolDowns')?.remove();
        document.querySelector('.previewCartInfo')?.remove();
        document.querySelector('[data-shipping-progress]')?.classList.add('progress-hidden', 'none');
        document.querySelector('.message[data-shipping-message]').innerHTML = `Free shipping for all orders over ${Shopify.formatMoney((free_shipping_price * 100), window.money_format)}!`;
      }

      // Check user preference BEFORE syncing
      const userWantsOff = userWantsToggleOff();
      
      // Only sync if user is NOT actively toggling AND hasn't explicitly turned it off
      if (!isUserToggling && !userWantsOff) {
        await syncInsuranceCheckboxState();
      }
      
      // After cart HTML is replaced, ensure toggle stays OFF if user wants it off
      await delay(50);
      const insurePrdInputAfterUpdate = document.querySelector('input[name="insure_prd_input"]');
      if (insurePrdInputAfterUpdate) {
        const userChoice = sessionStorage.getItem('insure_prd_user_choice');
        const manuallyToggled = sessionStorage.getItem('insure_prd_manually_toggled');
        
        // PRIORITY: If user wants it OFF, enforce it immediately - no exceptions
        if (manuallyToggled === 'true' && userChoice === 'off') {
          insurePrdInputAfterUpdate.checked = false;
          insurePrdInputAfterUpdate.removeAttribute('checked');
        } else if (isUserToggling) {
          // User is actively toggling - enforce their current choice
          if (userChoice === 'off' && insurePrdInputAfterUpdate.checked) {
            insurePrdInputAfterUpdate.checked = false;
            insurePrdInputAfterUpdate.removeAttribute('checked');
          }
        }
      }
      
      // Ensure insurance product is hidden in cart list
      hideInsuranceProductInCart();
    } catch (error) {
      console.error('Error updating item:', error);
    } finally {
      _isUpdatingCartDOM = false;
    }
  };

  // Hide insurance product in the cart list
  function hideInsuranceProductInCart() {
    try {
      // Find all cart items and hide the insurance product
      const cartItems = document.querySelectorAll('.previewCartItem[data-item-row]');
      cartItems.forEach(item => {
        // Check if this is the insurance product by checking the remove button's data-cart-remove-id
        const removeButton = item.querySelector('[data-cart-remove-id]');
        if (removeButton) {
          const itemId = removeButton.getAttribute('data-cart-remove-id');
          if (itemId && Number(itemId) === insuranceVariantId) {
            item.classList.add('hide_me_none');
            item.style.display = 'none';
          }
        }
      });
    } catch (error) {
      console.error('Error hiding insurance product:', error);
    }
  }

  // Check if user wants toggle OFF
  function userWantsToggleOff() {
    const manuallyToggled = sessionStorage.getItem('insure_prd_manually_toggled');
    const userChoice = sessionStorage.getItem('insure_prd_user_choice');
    
    // If user has manually toggled and choice is 'off', they want it off
    if (manuallyToggled === 'true' && userChoice === 'off') {
      return true; // User explicitly turned it off
    }
    
    // Also check current state if user has manually toggled
    if (manuallyToggled === 'true') {
      const insurePrdInput = document.querySelector('input[name="insure_prd_input"]');
      if (insurePrdInput && !insurePrdInput.checked) {
        // User manually turned it off - update stored choice to be sure
        if (userChoice !== 'off') {
          sessionStorage.setItem('insure_prd_user_choice', 'off');
        }
        return true;
      }
    }
    return false;
  }

  // Sync checkbox state with cart after updates
  async function syncInsuranceCheckboxState() {
    try {
      // Don't sync if user is actively toggling
      if (isUserToggling) return;
      
      // Don't sync if user explicitly wants it off
      if (userWantsToggleOff()) {
        const insurePrdInput = document.querySelector('input[name="insure_prd_input"]');
        if (insurePrdInput) {
          // Ensure checkbox is off
          if (insurePrdInput.checked) {
            insurePrdInput.checked = false;
            insurePrdInput.removeAttribute('checked');
          }
        }
        return; // Exit early - don't proceed with any sync logic
      }
      
      const cart = await getCart();
      if (!cart || !cart.items) return;
      const insuranceItem = cart.items.find(item => item.variant_id == insuranceVariantId);
      const nonInsuranceItems = cart.items.filter(item => item.variant_id != insuranceVariantId);
      const insurePrdInput = document.querySelector('input[name="insure_prd_input"]');
      
      if (insurePrdInput) {
        // Double-check user preference hasn't changed during async operation
        if (userWantsToggleOff()) {
          if (insurePrdInput.checked) {
            insurePrdInput.checked = false;
            insurePrdInput.removeAttribute('checked');
          }
          return;
        }
        
        // If there are products in cart, toggle should be ON
        if (nonInsuranceItems.length > 0) {
          // CRITICAL: Never turn on if user explicitly wants it off
          if (userWantsToggleOff()) {
            // User wants it OFF - ensure it stays off
            if (insurePrdInput.checked) {
              insurePrdInput.checked = false;
              insurePrdInput.removeAttribute('checked');
            }
            // Don't set line_item_key or do anything else - just exit
            return;
          }
          
          // Only turn on if user hasn't explicitly turned it off
          if (!insurePrdInput.checked) {
            insurePrdInput.checked = true;
            insurePrdInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
          
          // Set line_item_key if insurance is in cart
          if (insuranceItem && !insurePrdInput.hasAttribute('line_item_key')) {
            insurePrdInput.setAttribute('line_item_key', insuranceItem.key);
          }
        } else {
          // No products in cart - toggle should be OFF and insurance should be removed
          if (insurePrdInput.checked) {
            insurePrdInput.checked = false;
            insurePrdInput.removeAttribute('checked');
            insurePrdInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
          
          // Remove insurance if it's in cart
          if (insuranceItem) {
            const lineItemKey = insurePrdInput.getAttribute('line_item_key') || insuranceItem.key;
            if (lineItemKey) {
              const data = { id: lineItemKey, quantity: 0 };
              await updateItem(data);
            }
            insurePrdInput.removeAttribute('line_item_key');
          } else {
            // No insurance in cart, just remove line_item_key
            insurePrdInput.removeAttribute('line_item_key');
          }
        }
      }
    } catch (error) {
      console.error('Error syncing insurance checkbox:', error);
    }
  }

  const updateMainCart = async (cart) => {
    try {
      const sectionId = document.querySelector('#main-cart-items').getAttribute('data-id');

      const cartElement = document.querySelector('[data-cart]');
      const cartContent = cartElement.querySelector('[data-cart-content]');
      const cartTotals = cartElement.querySelector('[data-cart-total]');

      const cartLoading = `
      <div class="loading-overlay loading-overlay--custom">
        <div class="loading-overlay__spinner">
          <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
            <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
          </svg>
        </div>
      </div>`;

      const loadingClass = 'is-loading';

      cartElement.classList.add(loadingClass);
      cartElement.insertAdjacentHTML('afterbegin', cartLoading);

      const response = await fetch(`/cart?section_id=${sectionId}`);
      const data = await response.text();

      const jsPreventedData = data.replaceAll('cart-coupon-discount', 'div');
      const parsedResponse = new DOMParser().parseFromString(jsPreventedData, 'text/html');

      cartElement.classList.remove(loadingClass);
      cartElement.querySelector('.loading-overlay').remove();

      if (cart.item_count > 0) {
        const contentCart = parsedResponse.querySelector('[data-cart-content] .cart').innerHTML;
        const subTotal = parsedResponse.querySelector('[data-cart-total] .cart-total-subtotal').innerHTML;
        const grandTotal = parsedResponse.querySelector('[data-cart-total] .cart-total-grandtotal').innerHTML;
        const savings = parsedResponse.querySelector('[data-cart-total] .cart-total-savings').innerHTML;

        cartContent.querySelector('.cart').innerHTML = contentCart;
        cartTotals.querySelector('.cart-total-subtotal').innerHTML = subTotal;
        cartTotals.querySelector('.cart-total-grandtotal').innerHTML = grandTotal;
        cartTotals.querySelector('.cart-total-savings').innerHTML = savings;

        const calculatorShipping = parsedResponse.querySelector('.haloCalculatorShipping');
        if (calculatorShipping) {
          const existingCalculator = cartElement.querySelector('.haloCalculatorShipping');
          if (existingCalculator) {
            existingCalculator.replaceWith(calculatorShipping);
          }
        }

        document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));

        document.querySelectorAll('[data-free-shipping-wrapper]').forEach(freeShippingWrapper => {
          const changeEvent = new Event('change', { bubbles: true })
          freeShippingWrapper.dispatchEvent(changeEvent);
        })
      } else {
        const contentCart = parsedResponse.querySelector('#main-cart-items').innerHTML;
        const headerCart = parsedResponse.querySelector('.page-header').innerHTML;

        document.querySelector('#main-cart-items').innerHTML = contentCart;
        document.querySelector('.page-header').innerHTML = headerCart;

        document.querySelectorAll('[data-free-shipping-wrapper]').forEach(freeShippingWrapper => {
          const changeEvent = new Event('change', { bubbles: true })
          freeShippingWrapper.dispatchEvent(changeEvent);
        })
      }
    } catch (error) {
      console.error('Error updating cart:', error);
    }
  };

  function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  function getInsureIsAdded() {
    if (sessionStorage.getItem('insure_prd_input_checked') !== null) {
      return sessionStorage.getItem('insure_prd_input_checked') ;
    }
  }

  async function handleInsProductInput() {
    const insurePrdInput = document.querySelector('input[name="insure_prd_input"]');
    if (!insurePrdInput) return;
    
    const isChecked = insurePrdInput.checked;
    const IsProductAdded = document.querySelector('[line_item_key]') ? true : false;
    
    // Mark that user has manually toggled - store the state IMMEDIATELY
    userManuallyToggled = true;
    sessionStorage.setItem('insure_prd_manually_toggled', 'true');
    // Also store the current checked state
    sessionStorage.setItem('insure_prd_user_choice', isChecked ? 'on' : 'off');
    
    // Set isUserToggling flag to prevent sync interference - keep it active longer
    isUserToggling = true;
    
    if (isChecked) {
      // Toggle is ON - Add to cart if not already added
      if (!IsProductAdded) {
        await addInsuranceToCart();
        // Only update cart if not in template-cart page
        if (!document.querySelector(".cart.template-cart")) {
          await updateCart();
        }
      }
    } else {
      // Toggle is OFF - Remove from cart if it's added
      if (IsProductAdded) {
        const id = document.querySelector('[line_item_key]')?.getAttribute('line_item_key');
        if (id) {
          const quantity = 0;
          const data = { id, quantity };
          await updateItem(data);
          // Only update cart if not in template-cart page
          // But skip sync to prevent it from turning back on
          if (!document.querySelector(".cart.template-cart")) {
            // Update cart but skip syncInsuranceCheckboxState
            await updateCartWithoutSync();
          }
        }
      }
    }
    
    // Keep protection active for longer to prevent sync interference
    setTimeout(() => {
      isUserToggling = false;
    }, 2000); // Increased to 2 seconds
  }

  document.addEventListener("click", async function (event) {
    const slider = event.target.closest(".insure_prd_slider");
    const switchLabel = event.target.closest(".insure_prd_switch");
    const checkbox = event.target.closest('input[name="insure_prd_input"]');
    
    if (slider || switchLabel || checkbox) {
      // Mark that user is actively toggling
      isUserToggling = true;
      
      // Prevent other handlers from interfering
      event.stopPropagation();
      
      // Get the checkbox element
      const insurePrdInput = document.querySelector('input[name="insure_prd_input"]');
      if (!insurePrdInput) {
        isUserToggling = false;
        return;
      }
      
      // If clicking on slider or label, toggle the checkbox state
      if (slider || switchLabel) {
        // Toggle the checkbox state
        insurePrdInput.checked = !insurePrdInput.checked;
      }
      
      // Immediately update user choice to reflect the new state - BEFORE any async operations
      const newCheckedState = insurePrdInput.checked;
      userManuallyToggled = true;
      sessionStorage.setItem('insure_prd_manually_toggled', 'true');
      sessionStorage.setItem('insure_prd_user_choice', newCheckedState ? 'on' : 'off');
      
      // If turning off, remove checked attribute immediately
      if (!newCheckedState) {
        insurePrdInput.checked = false;
        insurePrdInput.removeAttribute('checked');
      }
      
      // Prevent any sync operations during user toggle
      isUserToggling = true;
      
      // Wait a moment for checkbox state to update
      await delay(50);
      
      // Ensure checkbox state matches what user clicked (don't let sync override)
      if (insurePrdInput.checked !== newCheckedState) {
        insurePrdInput.checked = newCheckedState;
        if (!newCheckedState) {
          insurePrdInput.removeAttribute('checked');
        }
      }
      
      if (!document.querySelector(".cart.template-cart")) {
        await handleInsProductInput();
      }
      
      // Store the state
      sessionStorage.setItem('insure_prd_input_checked', newCheckedState);
      console.log("Toggle state:", newCheckedState);
      
      // Reset flag after a longer delay to prevent sync interference
      setTimeout(() => {
        // Double-check user still wants it off before resetting flag
        const userChoice = sessionStorage.getItem('insure_prd_user_choice');
        if (userChoice === 'off') {
          // User wants it off - keep protection a bit longer
          setTimeout(() => {
            isUserToggling = false;
          }, 500);
        } else {
          isUserToggling = false;
        }
      }, 2000); // Increased delay to prevent sync interference
    }
  });

  if (document.querySelector(".cart.template-cart")) {
    document.addEventListener("click", async function (event) {
      const slider = event.target.closest(".insure_prd_slider");
      const switchLabel = event.target.closest(".insure_prd_switch");
      const checkbox = event.target.closest('input[name="insure_prd_input"]');
      
      if (slider || switchLabel || checkbox) {
        // Mark that user is actively toggling
        isUserToggling = true;
        
        // Prevent other handlers from interfering
        event.stopPropagation();
        
        // Get the checkbox element
        const insurePrdInput = document.querySelector('input[name="insure_prd_input"]');
        if (!insurePrdInput) {
          isUserToggling = false;
          return;
        }
        
        // If clicking on slider or label, toggle the checkbox state
        if (slider || switchLabel) {
          // Toggle the checkbox state
          insurePrdInput.checked = !insurePrdInput.checked;
        }
        
        // Immediately update user choice to reflect the new state - BEFORE any async operations
        const newCheckedState = insurePrdInput.checked;
        userManuallyToggled = true;
        sessionStorage.setItem('insure_prd_manually_toggled', 'true');
        sessionStorage.setItem('insure_prd_user_choice', newCheckedState ? 'on' : 'off');
        
        // If turning off, remove checked attribute immediately
        if (!newCheckedState) {
          insurePrdInput.checked = false;
          insurePrdInput.removeAttribute('checked');
        }
        
        // Prevent any sync operations during user toggle
        isUserToggling = true;
        
        // Wait a moment for checkbox state to update
        await delay(50);
        
        // Ensure checkbox state matches what user clicked
        if (insurePrdInput.checked !== newCheckedState) {
          insurePrdInput.checked = newCheckedState;
          if (!newCheckedState) {
            insurePrdInput.removeAttribute('checked');
          }
        }
        
        await handleInsProductInput();
        Shopify.getCart(async (cart) => {
          await updateMainCart(cart); 
        });
        
        // Reset flag after a longer delay to prevent sync interference
        setTimeout(() => {
          // Double-check user still wants it off before resetting flag
          const userChoice = sessionStorage.getItem('insure_prd_user_choice');
          if (userChoice === 'off') {
            // User wants it off - keep protection a bit longer
            setTimeout(() => {
              isUserToggling = false;
            }, 500);
          } else {
            isUserToggling = false;
          }
        }, 2000); // Increased delay to prevent sync interference
      }
    });
  }

  window.addEventListener("insure-start-add",async  function () {
    // setTimeout(async () => {
      const cart = await getCart();
      if (!cart || !cart.items) return;
      const insuranceItem = cart.items.find(item => item.variant_id == insuranceVariantId);
      // const getInputCheked = getInsureIsAdded();

      if (window.insuranceStepSecondAdded && window.insuranceStepOneAdded && !insuranceItem) {
        // if () {
            document.querySelector('.insure_prd_slider')?.click();  
        // } 
      }


      console.log("global event fires");

    // }, 2500);
    
  });

  // Auto-add insurance product on page load if checkbox is checked by default
  async function checkAndAddInsuranceOnLoad() {
    const insurePrdInput = document.querySelector('input[name="insure_prd_input"]');
    if (!insurePrdInput) {
      // Wait and retry
      await delay(1000);
      const retryInput = document.querySelector('input[name="insure_prd_input"]');
      if (!retryInput) return;
    }
    
    // Wait a bit for cart to be ready
    await delay(500);
    
    try {
      // Check if user manually toggled before - RESTORE STATE FIRST
      const manuallyToggled = sessionStorage.getItem('insure_prd_manually_toggled');
      const userChoice = sessionStorage.getItem('insure_prd_user_choice');
      
      if (manuallyToggled === 'true') {
        userManuallyToggled = true;
      }
      
      // Get current cart state
      const cart = await getCart();
      if (!cart || !cart.items) return;
      const nonInsuranceItems = cart.items.filter(item => item.variant_id != insuranceVariantId);
      const insuranceItem = cart.items.find(item => item.variant_id == insuranceVariantId);
      
      const finalInput = document.querySelector('input[name="insure_prd_input"]');
      if (!finalInput) return;
      
      // PRIORITY 1: If user explicitly turned it OFF, respect that choice immediately
      if (manuallyToggled === 'true' && userChoice === 'off') {
        // User wants it OFF - set checkbox to false immediately, regardless of HTML state
        finalInput.checked = false;
        finalInput.removeAttribute('checked');
        
        // Remove insurance from cart if it exists
        if (insuranceItem) {
          const lineItemKey = finalInput.getAttribute('line_item_key') || insuranceItem.key;
          if (lineItemKey) {
            const data = { id: lineItemKey, quantity: 0 };
            await updateItem(data);
            finalInput.removeAttribute('line_item_key');
          }
        }
        return; // Don't proceed with auto-enable logic
      }
      
      // PRIORITY 2: If there are products in cart, turn on toggle (unless user manually turned it off)
      if (nonInsuranceItems.length > 0) {
        // Check if user wants it off - use the helper function
        if (!userWantsToggleOff()) {
          finalInput.checked = true;
          finalInput.dispatchEvent(new Event('change', { bubbles: true }));
          
          // Add insurance if not in cart
          if (!insuranceItem) {
            await addInsuranceToCart();
            await delay(300);
            if (!document.querySelector(".cart.template-cart")) {
              await updateCart();
            }
          } else {
            // Set line_item_key if insurance is in cart
            if (!finalInput.hasAttribute('line_item_key')) {
              finalInput.setAttribute('line_item_key', insuranceItem.key);
            }
          }
        } else {
          // User wants it OFF - make sure insurance is removed
          finalInput.checked = false;
          finalInput.removeAttribute('checked');
          if (insuranceItem) {
            const lineItemKey = finalInput.getAttribute('line_item_key') || insuranceItem.key;
            if (lineItemKey) {
              const data = { id: lineItemKey, quantity: 0 };
              await updateItem(data);
              finalInput.removeAttribute('line_item_key');
            }
          }
        }
      } else {
        // No products - turn off toggle
        if (finalInput.checked) {
          finalInput.checked = false;
          finalInput.removeAttribute('checked');
          finalInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    } catch (error) {
      console.error('Error checking insurance on load:', error);
    }
  }

  // Run on page load
  checkAndAddInsuranceOnLoad();

  // Track if user is actively toggling to prevent sync from interfering
  let isUserToggling = false;

  // Function to sync checkbox state with visual toggle
  function syncCheckboxWithToggle() {
    // Don't sync if user is actively toggling
    if (isUserToggling) return;
    
    const insurePrdInput = document.querySelector('input[name="insure_prd_input"]');
    if (!insurePrdInput) return;
    
    // Check if user wants it off - but only if they explicitly set it to off
    const manuallyToggled = sessionStorage.getItem('insure_prd_manually_toggled');
    const userChoice = sessionStorage.getItem('insure_prd_user_choice');
    
    // If user explicitly turned it off, enforce that state
    if (manuallyToggled === 'true' && userChoice === 'off') {
      if (insurePrdInput.checked) {
        insurePrdInput.checked = false;
        insurePrdInput.removeAttribute('checked');
        // Don't dispatch change event here to avoid triggering handlers
      }
      return; // Don't proceed with other sync logic
    }
    
    // Ensure visual state matches checkbox state
    const slider = document.querySelector('.insure_prd_slider');
    if (slider) {
      // The CSS handles the visual state based on :checked pseudo-class
      // But we can force a re-render by toggling a class if needed
      if (insurePrdInput.checked) {
        slider.classList.remove('toggle-off');
      } else {
        slider.classList.add('toggle-off');
      }
    }
  }

  // Check and enforce user preference after a delay (in case HTML has checked="true")
  // But only if user hasn't manually toggled
  setTimeout(() => {
    const manuallyToggled = sessionStorage.getItem('insure_prd_manually_toggled');
    const userChoice = sessionStorage.getItem('insure_prd_user_choice');
    
    // Only sync if user hasn't explicitly set a preference, or if they want it on
    if (manuallyToggled !== 'true' || userChoice === 'on') {
      syncCheckboxWithToggle();
    } else if (userChoice === 'off') {
      // User wants it off - enforce it
      const insurePrdInput = document.querySelector('input[name="insure_prd_input"]');
      if (insurePrdInput && insurePrdInput.checked) {
        insurePrdInput.checked = false;
        insurePrdInput.removeAttribute('checked');
      }
    }
  }, 1000);
  
  // Re-sync the toggle when the cart can have changed, instead of polling every 5 seconds on
  // every page: after a cart-update event, when the cart drawer opens, and when the cart HTML
  // is re-rendered. Same condition as the old interval - respect the user's choice.
  let _toggleSyncTimer = null;
  function scheduleToggleSync() {
    clearTimeout(_toggleSyncTimer);
    _toggleSyncTimer = setTimeout(() => {
      if (isUserToggling) return;
      const manuallyToggled = sessionStorage.getItem('insure_prd_manually_toggled');
      const userChoice = sessionStorage.getItem('insure_prd_user_choice');
      // Only sync if user hasn't explicitly turned it off
      if (manuallyToggled !== 'true' || userChoice !== 'off') {
        syncCheckboxWithToggle();
      }
    }, 150);
  }

  document.addEventListener('cart-update', scheduleToggleSync);

  new MutationObserver(function () {
    if (document.body.classList.contains('cart-sidebar-show')) scheduleToggleSync();
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

  document.querySelectorAll('.previewCart, #halo-cart-sidebar, [data-cart]').forEach(function (el) {
    new MutationObserver(scheduleToggleSync).observe(el, { childList: true, subtree: true });
  });

  // Also listen for direct input change events (in case click doesn't fire)
  document.addEventListener('change', async function(event) {
    if (event.target && event.target.name === 'insure_prd_input') {
      // Don't interfere if already processing
      if (isUserToggling) return;
      
      // Mark as user toggling to prevent sync interference IMMEDIATELY
      isUserToggling = true;
      
      // Ensure the checkbox state is correct
      const isChecked = event.target.checked;
      
      // Update user choice based on current state IMMEDIATELY
      userManuallyToggled = true;
      sessionStorage.setItem('insure_prd_manually_toggled', 'true');
      if (isChecked) {
        sessionStorage.setItem('insure_prd_user_choice', 'on');
      } else {
        sessionStorage.setItem('insure_prd_user_choice', 'off');
        // If unchecked, make sure it's really unchecked
        event.target.checked = false;
        // Remove checked attribute if it exists
        event.target.removeAttribute('checked');
      }
      
      await delay(50);
      await handleInsProductInput();
      
      // Reset flag after a longer delay
      setTimeout(() => {
        // Double-check user still wants it off before resetting flag
        const userChoice = sessionStorage.getItem('insure_prd_user_choice');
        if (userChoice === 'off') {
          // User wants it off - keep protection a bit longer
          setTimeout(() => {
            isUserToggling = false;
          }, 500);
        } else {
          isUserToggling = false;
        }
      }, 2000);
    }
  });
  
  // Also listen for input events to catch any state changes
  document.addEventListener('input', function(event) {
    if (event.target && event.target.name === 'insure_prd_input') {
      // Don't interfere if user is actively toggling
      if (isUserToggling) return;
      
      // If user wants it off, enforce it immediately
      if (userWantsToggleOff()) {
        if (event.target.checked) {
          event.target.checked = false;
          event.target.removeAttribute('checked');
        }
        return;
      }
      
      // Ensure visual state matches checkbox state
      syncCheckboxWithToggle();
    }
  });

  // Listen for cart updates - when a product is added, turn on toggle and add insurance
  let previousCartItemCount = 0;
  let previousNonInsuranceCount = 0;
  let isProcessingCartUpdate = false;
  let userManuallyToggled = false; // Track if user manually toggled

  // Function to turn on toggle and add insurance when product is added
  async function turnOnToggleAndAddInsurance() {
    if (isProcessingCartUpdate) return;
    
    // Don't auto-turn on if user is actively toggling
    if (isUserToggling) return;
    
    // Don't auto-turn on if user manually turned it off
    if (userWantsToggleOff()) {
      return; // Respect user's choice to keep it off
    }
    
    try {
      const insurePrdInput = document.querySelector('input[name="insure_prd_input"]');
      if (!insurePrdInput) {
        // Wait a bit and try again if checkbox doesn't exist yet
        await delay(300);
        const retryInput = document.querySelector('input[name="insure_prd_input"]');
        if (!retryInput) {
          // Try one more time after cart updates
          await delay(500);
          const finalRetry = document.querySelector('input[name="insure_prd_input"]');
          if (!finalRetry) return;
        }
      }

      const finalInput = document.querySelector('input[name="insure_prd_input"]');
      if (!finalInput) return;

      // Double-check user preference hasn't changed
      if (isUserToggling || userWantsToggleOff()) {
        return;
      }

      // Get current cart state
      const cart = await getCart();
      if (!cart || !cart.items) return;
      const insuranceItem = cart.items.find(item => item.variant_id == insuranceVariantId);
      const nonInsuranceItems = cart.items.filter(item => item.variant_id != insuranceVariantId);

      // Only proceed if there are non-insurance products in cart
      if (nonInsuranceItems.length === 0) return;

      // Final check before proceeding
      if (isUserToggling || userWantsToggleOff()) {
        return;
      }

      isProcessingCartUpdate = true;

      // Turn on the toggle when a product is added (unless user manually turned it off)
      if (!userWantsToggleOff() && !isUserToggling) {
        finalInput.checked = true;
        // Trigger change event to update UI
        finalInput.dispatchEvent(new Event('change', { bubbles: true }));

        // Add insurance to cart if not already added
        if (!insuranceItem) {
          await addInsuranceToCart();
          
          // Wait a bit for cart to update
          await delay(300);
          
          // Update cart display
          if (!document.querySelector(".cart.template-cart")) {
            await updateCart();
          }
        } else {
          // Insurance already in cart, just ensure line_item_key is set
          if (!finalInput.hasAttribute('line_item_key')) {
            finalInput.setAttribute('line_item_key', insuranceItem.key);
          }
        }
      }

      isProcessingCartUpdate = false;
    } catch (error) {
      console.error('Error turning on toggle and adding insurance:', error);
      isProcessingCartUpdate = false;
    }
  }

  // Function to turn off toggle and remove insurance
  async function turnOffToggleAndRemoveInsurance() {
    if (isProcessingCartUpdate) return;
    
    try {
      const insurePrdInput = document.querySelector('input[name="insure_prd_input"]');
      if (!insurePrdInput) return;

      isProcessingCartUpdate = true;

      // Turn off the toggle
      insurePrdInput.checked = false;
      insurePrdInput.dispatchEvent(new Event('change', { bubbles: true }));

      // Remove insurance from cart if it's added
      const lineItemKey = insurePrdInput.getAttribute('line_item_key');
      if (lineItemKey) {
        const data = { id: lineItemKey, quantity: 0 };
        await updateItem(data);
        
        // Wait a bit for cart to update
        await delay(300);
        
        // Update cart display
        if (!document.querySelector(".cart.template-cart")) {
          await updateCart();
        }
      }

      isProcessingCartUpdate = false;
    } catch (error) {
      console.error('Error turning off toggle and removing insurance:', error);
      isProcessingCartUpdate = false;
    }
  }

  // Check cart and turn on/off toggle as needed
  async function checkCartAndTurnOnToggle() {
    try {
      // Don't check if user is actively toggling
      if (isUserToggling) return;
      
      const cart = await getCart();
      if (!cart || !cart.items) return;
      const nonInsuranceItems = cart.items.filter(item => item.variant_id != insuranceVariantId);
      const currentNonInsuranceCount = nonInsuranceItems.length;

      // If non-insurance items increased, turn on toggle (only if user hasn't turned it off)
      if (currentNonInsuranceCount > previousNonInsuranceCount && currentNonInsuranceCount > 0) {
        // Only turn on if user hasn't explicitly turned it off
        if (!userWantsToggleOff()) {
          await turnOnToggleAndAddInsurance();
        }
        previousNonInsuranceCount = currentNonInsuranceCount;
      } 
      // If all products are removed (no non-insurance items), turn off toggle and remove insurance
      else if (currentNonInsuranceCount === 0 && previousNonInsuranceCount > 0) {
        await turnOffToggleAndRemoveInsurance();
        previousNonInsuranceCount = 0;
      } 
      else {
        previousNonInsuranceCount = currentNonInsuranceCount;
      }
    } catch (error) {
      console.error('Error checking cart:', error);
    }
  }

  // Debounced version of checkCartAndTurnOnToggle to prevent rapid calls
  const debouncedCheckCart = debounce(checkCartAndTurnOnToggle, 2000);

  // Listen for cart-update events
  document.addEventListener('cart-update', async function(event) {
    const cart = event.detail;
    if (!cart || !cart.items) {
      // If no cart in event, use debounced check
      debouncedCheckCart();
      return;
    }

    // Update cache with event data so we don't re-fetch
    _cachedCart = cart;
    _cartFetchedAt = Date.now();
    // Also update global Shopify cache
    if (typeof Shopify !== 'undefined') {
      Shopify._cartCache = cart;
      Shopify._cartCacheTime = _cartFetchedAt;
    }

    try {
      const currentItemCount = cart.items.length;
      const nonInsuranceItems = cart.items.filter(item => item.variant_id != insuranceVariantId);
      const currentNonInsuranceCount = nonInsuranceItems.length;

      // When a product is added (count increased), always turn on toggle and add insurance
      if (currentNonInsuranceCount > previousNonInsuranceCount && currentNonInsuranceCount > 0) {
        // A product was just added - turn on toggle and add insurance
        await turnOnToggleAndAddInsurance();
      }
      // When all products are removed (no non-insurance items left), turn off toggle and remove insurance
      else if (currentNonInsuranceCount === 0 && previousNonInsuranceCount > 0) {
        // All products were removed - turn off toggle and remove insurance
        await turnOffToggleAndRemoveInsurance();
      }

      // Update previous counts
      previousCartItemCount = currentItemCount;
      previousNonInsuranceCount = currentNonInsuranceCount;
    } catch (error) {
      console.error('Error handling cart update:', error);
    }
  });

  // Listen for add to cart button clicks directly
  document.addEventListener('click', async function(event) {
    const addToCartBtn = event.target.closest('[data-btn-addtocart], .add_to_bag, [name="add"]');
    if (addToCartBtn && !addToCartBtn.closest('.shop_insure_protect_container')) {
      // Product is being added - invalidate cache and debounced check
      invalidateCartCache();
      debouncedCheckCart();
    }

    // Listen for remove button clicks
    const removeBtn = event.target.closest('[data-cart-remove], .cart-remove, .previewCartItem-remove');
    if (removeBtn && !removeBtn.closest('.shop_insure_protect_container')) {
      // Product is being removed - invalidate cache and debounced check
      invalidateCartCache();
      debouncedCheckCart();
    }
  });

  // Also listen for when cart sidebar opens (product might have been added)
  let _lastSidebarState = document.body.classList.contains('cart-sidebar-show');
  const bodyObserver = new MutationObserver(function(mutations) {
    const sidebarNowOpen = document.body.classList.contains('cart-sidebar-show');
    // Only act when sidebar transitions from closed to open
    if (sidebarNowOpen && !_lastSidebarState) {
      _lastSidebarState = sidebarNowOpen;
      // Don't interfere if user is actively toggling
      if (isUserToggling) return;

      // Check user preference FIRST
      if (userWantsToggleOff()) {
        const insurePrdInput = document.querySelector('input[name="insure_prd_input"]');
        if (insurePrdInput) {
          insurePrdInput.checked = false;
          insurePrdInput.removeAttribute('checked');
        }
        return;
      }

      invalidateCartCache();
      debouncedCheckCart();
    }
    _lastSidebarState = sidebarNowOpen;
  });

  bodyObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ['class']
  });

  // Watch for cart HTML updates and ensure toggle is ON (unless user turned it off)
  const cartObserver = new MutationObserver(function(mutations) {
    // Skip if WE are the ones updating the cart DOM (prevents feedback loop)
    if (_isUpdatingCartDOM) return;

    let hasRelevantChange = false;
    for (const mutation of mutations) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        hasRelevantChange = true;
        break;
      }
    }
    if (!hasRelevantChange) return;

    // Don't interfere if user is actively toggling
    if (isUserToggling) return;

    // Check user preference FIRST (sync, no fetch needed)
    if (userWantsToggleOff()) {
      const insurePrdInput = document.querySelector('input[name="insure_prd_input"]');
      if (insurePrdInput) {
        insurePrdInput.checked = false;
        insurePrdInput.removeAttribute('checked');
      }
      return;
    }

    // Use debounced check instead of direct fetch
    debouncedCheckCart();
  });

  // Observe the cart container for changes
  const cartContainer = document.querySelector('.previewCart, #halo-cart-sidebar');
  if (cartContainer) {
    cartObserver.observe(cartContainer, {
      childList: true,
      subtree: true
    });
  }

  // Initialize previous cart count on load
  async function initializeCartCount() {
    try {
      const cart = await getCart();
      if (!cart || !cart.items) return;
      previousCartItemCount = cart.items.length;
      const nonInsuranceItems = cart.items.filter(item => item.variant_id != insuranceVariantId);
      previousNonInsuranceCount = nonInsuranceItems.length;
    } catch (error) {
      console.error('Error initializing cart count:', error);
    }
  }

  // Initialize cart count after a delay
  setTimeout(initializeCartCount, 1000);
  
  // Removed periodic polling setInterval - event-driven checks (cart-update, click handlers,
  // mutation observers) are sufficient and periodic polling causes 429 rate limiting

  // Hide insurance product in cart whenever cart updates
  document.addEventListener('cart-update', function() {
    setTimeout(hideInsuranceProductInCart, 100);
  });

  // Also hide on initial load
  setTimeout(hideInsuranceProductInCart, 1500);


});


